<template>
  <span class="mytooltip tooltip-effect-5">
    <small class="text-muted">
      <span v-if="isText">{{ isText }}</span>
      <span v-if="!isText"><i class="mdi mdi-information"></i></span>
    </small>
    <span class="tooltip-content clearfix" v-if="msg">
      <span class="tooltip-text p-t-10">{{ msg }}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'Tooltip',
  props: ["msg", "isText"]
}
</script>

<style scoped>

</style>